import React, { Component } from 'react';

import { PictureAndText, SimpleList, IconValueList } from '../../molecules';
import { Text, Line, MaterialIcon, Button } from '../../atoms';
import { sideBarOptions } from '../../models';

export class Sidebar extends Component {

	renderItems() {
		return sideBarOptions["secondaryOptions"].map(item =>
			<li 
				key={item.label} 
				className={`item waves-effect flex -al-c ${item.className}`} 
				onClick={this.props.actions[item.icon]}
			>
				<div className="cointainer-option" onClick={()=> ""} id={"#"+item.id} >
					<MaterialIcon
						size="gnome"
						type={item.icon}
						color="grey"
					/> 
					<Text>{item.label}</Text>
				</div>
			</li>
		);
	};

	renderSpecialOptions() {
		if (this.props.auth.email == "contato@h2ocompany.com.br")
			return[
				<li className="special-option" key={1}>
					<Button clickAction={() => this.props.downloadAction("mensuration")}>Relatório de Mensuração</Button>
				</li>,
				<li className="special-option" key={2}>
					<Button clickAction={() => this.props.downloadAction("management")}>Relatório de  Gestão</Button>
				</li>,
				<li className="special-option" key={3}>
					<Button clickAction={() => this.props.downloadAction("comunication")}>Relatório de Comunicação</Button>
				</li>
			];
			else return null;
	}
	
	render() {
		return (
			<div className="sidebar">
			<div className="top" onClick={this.props.actions["home"]}>
			<h4 className="sidebar-tite">Sistema ARCA</h4>
			<Text>Diagnóstico de Gestão Estratégica da Água</Text>
			</div>
				<div className="mid">
				<IconValueList done={this.props.auth.done || {}} id="primary" clickAction={this.props.changeTabAction} items={sideBarOptions["primaryOptions"]} />
				</div>
				<Line />
				<div className="bottom">
				<ul className="icon-value-list">
					{this.renderItems()}
					<li>
						<a href="mailto:contato@h2ocompany.com.br" className="contact-us">Dúvidas para o preenchimento? contacte-nos via e-mail: contato@h2ocompany.com.br</a>
					</li>
					{this.renderSpecialOptions()}
				</ul>
			</div>
		</div>
		);
	}
}


// WEBPACK FOOTER //
// src/components/common/Sidebar.js